import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import styled from '@emotion/styled';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
const muiCache = createCache({
	"key": "mui",
	"prepend": true
});

// const data = [
//  ["1","Artificial Intelligence","df2323", "Active", "Oct 4,2021 - Dec 3, 2023","3","Internal","Addis Ababa Science and Technology University"],
//  ["2","Side Effects of Global Warming","df2323","Active", "Oct 4,2021 - Dec 3, 2023","4","Internal","Addis Ababa Science and Technology University"],
//  ["3","NanoTechnology","23fdfd","Pending", "Oct 4,2021 - Dec 3, 2023", "3","Internal","Addis Ababa Science and Technology University"],
//  ["4","Internationalization of the World","dfaffddf","Active", "Oct 4,2021 - Dec 3, 2023", "3","Internal","Addis Ababa Science and Technology University"],
//  ["5","Internationalization of the Africa","jhgfds","Expired", "Oct 4,2021 - Dec 3, 2023", "3","Internal","Addis Ababa Science and Technology University"],
//  ["6","Internationalization of the Ethiopia","dfaffadf","Expired", "Oct 4,2021 - Dec 3, 2023", "3","Internal","Addis Ababa Science and Technology University"],
//  ["7","Internationalization of the Addis Ababa","afadfa","Expired", "Oct 4,2021 - Dec 3, 2023", "3","Internal","Addis Ababa Science and Technology University"],
// ["8","Artificial Intelligence","12345t", "Active", "Oct 4,2021 - Dec 3, 2023","3","Internal","Addis Ababa Science and Technology University"],
//  ["9","Side Effects of Global Warming","df2323","Active", "Oct 4,2021 - Dec 3, 2023","4","Internal","Addis Ababa Science and Technology University"],
//  ["10","NanoTechnology","23fdfd","Pending", "Oct 4,2021 - Dec 3, 2023", "3","Internal","Addis Ababa Science and Technology University"],
//  ["11","Internationalization of the World","dfaffddf","Active", "Oct 4,2021 - Dec 3, 2023", "3","Internal","Addis Ababa Science and Technology University"],
//  ["12","Internationalization of the Africa","jhgfds","Expired", "Oct 4,2021 - Dec 3, 2023", "3","Internal","Addis Ababa Science and Technology University"],
//  ["13","Internationalization of the Ethiopia","dfaffadf","Expired", "Oct 4,2021 - Dec 3, 2023", "3","Internal","Addis Ababa Science and Technology University"],
//  ["14","Internationalization of the Addis Ababa","afadfa","Expired", "Oct 4,2021 - Dec 3, 2023", "3","Internal","Addis Ababa Science and Technology University"],

// ];


const StyledMUIDataTable=styled(MUIDataTable)(({theme})=>({
  background:theme.palette.background.default,
  height:'100%', 
    '& .tss-1l6och6-MUIDataTableHeadCell-fixedHeader':{
       padding:'5px 5px 5px 10px',
  },
    '& .tss-v24t37-MUIDataTableHeadCell-fixedHeader':{
       padding:'5px 5px 5px 10px',
  },


  //   '& .css-1nrlq1o-MuiFormControl-root':{
  //      padding:'16px 24px',
  // },
  // '& .css-1w1rijm-MuiButtonBase-root-MuiButton-root':{
  //   padding:'0px',
  //   textTransform:'none'
  // },
  // '& .css-1v17xvx-MuiTableCell-root':{
  //   padding:'5px',
  //   textTransform:'none'
  // },
  // '& .css-10ud224-MuiTableCell-root':{
  //   padding:'0px'
  // },
  // '& .css-nfmglb-MuiTableCell-root':{
  //   padding:'0px'
  // },
  //  '& .tss-1vsygk-MUIDataTableFilterList-root':{
  //   gap:'8px',

  // },
}))
export default function ActiveResearch() {
  const {changed}=useAuth();
  const api=useAxiosPrivate()
  const [data,setData]=useState([])
   useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const getData=async ()=>{
        try{
          const response=await api.get(`research/view/`,{
            signal:controller.signal
          })
          const result=response.data.map((value)=>{
            return([
              value.id,
              value.title,
              value.grant_code,
              value.status,
              `${value.start_date} - ${value.end_date}`,
              value.leh,
              value.type,
              value.institution,
            ])
          })
          isMounted &&  setData(result)}
        catch(err){
          console.error(err)
        }
      }
      getData();
      return ()=>{
        isMounted=false;
        controller.abort()
      }
        },[changed])
  const columns = [
   {
  name: "id",
  label: "Research ID",
  options: {
   filter: true,
   sort: true,
   display:false,
  }
 },
 {
  name: "title",
  label: "Research Title",
  options: {
   filter: false,
   sort: true,
  }
 },
 {
  name: "g_code",
  label: "Grant Code",
  options: {
   filter: true,
   sort: true,
  }
 },
  {
  name: "status",
  label: "Status",
  options: {
   filter: true,
   sort: true,
   filterList:['Active'],
  }
 },
  {
  name: "duration",
  label: "Duration",
  options: {
   filter: true,
   sort: true,
  }
 },
  {
  name: "load",
  label: "LEH",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
  name: "type",
  label: "Type",
  options: {
   filter: true,
   sort: true,
   display:false,
  }
 },
  {
  name: "institution",
  label: "Institution",
  options: {
   filter: true,
   sort: true,
   display:false,

  }
 },
]
const researchOptions = {
  filterType: 'multiselect',
  selectableRows:"none",
  rowsPerPage:3,
  rowsPerPageOptions:[3,10,20,40],
  rowHover:false,
  // responsive:'scroll',
};
 return(
  <CacheProvider value={muiCache}>
  <StyledMUIDataTable
  title="Active Researches"
  data={data}
  columns={columns}
  options={researchOptions}
/></CacheProvider>
 ) 
}